import Vuex from 'vuex'
import general from './general'
import chat from '../app/chat/vuex'
import chatTemplates from '../app/chat-templates/vuex'
import reporting from '../app/reporting/vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    namespace: true,
    modules: {
        general,
        chat,
        'chat-templates': chatTemplates,
        reporting
    }
})
